<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import Button from 'primevue/button';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import GuestLayout from '@/Layouts/GuestLayout.vue';

defineProps({
  status: {
    type: String,
  },
});

const form = useForm({
  email: '',
});

const submit = () => {
  form.post(route('password.email'));
};
</script>

<template>
  <GuestLayout>
    <Head title="Mot de passe oublié"/>

    <div class="mt-6 text-sm text-gray-600">
      Vous avez oublié votre mot de passe? Pas de problème. Indiquez-nous
      simplement votre adresse e-mail et nous vous enverrons un lien de
      réinitialisation de mot de passe qui vous permettra d'en choisir un
      nouveau.
    </div>

    <div v-if="status" class="mt-6 text-sm font-medium text-green-600">
      {{ status }}
    </div>

    <form @submit.prevent="submit">
      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="email"
              fluid
              autofocus
              autocomplete="username"
              required
              v-model="form.email"
              :invalid="!!form.errors.email"
          />

          <label for="email">Adresse e-mail</label>
        </FloatLabel>

        <Message v-if="!!form.errors.email" severity="error">
          {{ form.errors.email }}
        </Message>
      </div>

      <div class="my-6 flex items-center justify-end">
        <Button type="submit" :disabled="form.processing">
          Réinitialiser le mot de passe
        </Button>
      </div>
    </form>
  </GuestLayout>
</template>
